import styled from 'react-emotion'

import { colours } from '../../theme'

const Item = styled('li')`
	font-size: ${props => (props.fontSize ? `${props.fontSize/1.2}rem` : '1rem')};
	font-weight: 600;
	color: ${colours.primary};
	line-height: 1;
	margin: 0;
	padding: 0.25rem 0.75rem;
`

export default Item
